import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useCurrentPurchaseOrderLink } from '@/lib/getMyLinks';
import { useConfirmPurchaseOrder } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router';

interface Props extends ModalProps {
  nameToSave: string;
}

export const ConfirmPurchaseOrderModal: FunctionComponent<Props> = props => {
  const navigate = useNavigate();
  const poLink = useCurrentPurchaseOrderLink();
  const [loading, setLoading] = useState(false);
  const confirmOrder = useConfirmPurchaseOrder(props.nameToSave);

  const onSubmit = async () => {
    setLoading(true);
    await confirmOrder();
    navigate(poLink);
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Confirm Order</h1>
        </Modal.Controls>
        <div className="my-2">Are you sure you want to submit this order?</div>
        <div className="flex justify-between pt-2 space-x-2">
          <Button onClick={props.close} loading={false} className="w-fit" variant={ButtonVariant.Mono} type="button">
            Cancel
          </Button>
          <Button loading={loading} className="w-fit" variant={ButtonVariant.Primary} onClick={onSubmit}>
            Confirm
          </Button>
        </div>
      </Card>
    </Modal>
  );
};
